const chatRouter = [
    {
        path: "chat",
        name: "list",
        component: () => import("@/views/admin/chat"),
        default: true,
        meta: {
            model: "chat",
            // requiresAuth: true,
        },
    },
];
export default chatRouter;